import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";
import {onDomReady} from "../../shared/ts/helpers/on-dom-ready";

let newsListAbortController = null
let isLoading = false
let pageToLoad = 2
/**
 * @type {number}
 */
let numberOfPages

function parseHtml(html) {
  return new DOMParser().parseFromString(html, 'text/html')
}

async function GetNewsList(form, page) {
  const ajaxUrl = form.getAttribute('action')
  const params = new URLSearchParams(new FormData(form))
  const container = 'news-container-' + form.dataset.container

  if (page) {
    params.set('tx_news_pi1[currentPage]', page)
  }

  if (newsListAbortController) {
    newsListAbortController.abort()
  }
  newsListAbortController = new AbortController()

  try {
    const response = await fetch(ajaxUrl, {
      method: 'POST',
      body: params,
      signal: newsListAbortController.signal,
    })
    const result = await response.text()
    const doc = parseHtml(result)
    const newsFormEl = doc.querySelector('form.news-filter-form')
    numberOfPages = parseInt(newsFormEl?.dataset.numberOfPages ?? '')
    if (Number.isNaN(numberOfPages)) {
      numberOfPages = 99
    }
    const ajaxDom = doc.getElementById(container)
    const containerEl = document.getElementById(container)
    if (containerEl && ajaxDom) {
      containerEl.innerHTML = ajaxDom.innerHTML
    }
  } catch (e) {
    if (e.name !== 'AbortError') {
      console.warn(e)
    }
  }
}

function init() {
  const newsForm = document.querySelector('form.news-filter-form')
  if (!newsForm) return

  const news = newsForm.closest('.news')
  if (!news) return

  const newsTrigger = news.querySelector('.news-list__trigger')

  numberOfPages = parseInt(newsForm?.dataset.numberOfPages ?? '')
  if (Number.isNaN(numberOfPages)) {
    numberOfPages = 99
  }

  news.querySelectorAll('.news-tools select').forEach(select => {
    select.addEventListener('change', () => {
      GetNewsList(newsForm, 0)
    })
  })

  news.querySelectorAll('.news-tools input').forEach(input => {
    input.addEventListener('keyup', () => {
      GetNewsList(newsForm, 0)
    })
  })

  newsForm.addEventListener('submit', (e) => {
    e.preventDefault()
    GetNewsList(newsForm, 0)
  })

  news.addEventListener('click', (e) => {
    const link = e.target.closest('.page-navigation a')
    if (!link) return
    e.preventDefault()
    const page = link.dataset.page
    const form = link.closest('.news')?.querySelector('form')
    if (form) GetNewsList(form, page)
  })

  /**
   * @type {IntersectionObserverCallback}
   */
  const loadMoreNewsEntries = (entries) => {
    // we always observe exactly one element
    if (!entries[0]?.isIntersecting ?? false) {
      return;
    }

    loadMoreNewsEntriesAjax(newsForm)
  }

  const loadMoreNewsEntriesAjax = async (form) => {
    if (isLoading) {
      return
    }

    if (pageToLoad > numberOfPages) {
      return
    }

    isLoading = true
    newsTrigger?.classList.add('is-loading')

    const ajaxUrl = form.getAttribute('action')
    const params = new URLSearchParams(new FormData(form))
    const container = 'news-container-' + form.dataset.container

    params.set('tx_news_pi1[currentPage]', pageToLoad)

    if (newsListAbortController) {
      newsListAbortController.abort()
    }
    newsListAbortController = new AbortController()

    try {
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        body: params,
        signal: newsListAbortController.signal,
      })
      const result = await response.text()
      const doc = parseHtml(result)
      const ajaxDom = doc.getElementById(container)
      const containerEl = document.getElementById(container)
      if (containerEl && ajaxDom) {
        containerEl.insertAdjacentHTML('beforeend', ajaxDom.innerHTML)
      }
      const updatedNumberOfPages = parseInt(containerEl?.querySelector('.pagination-info')?.dataset.pagination ?? '')
      if (Number.isNaN(updatedNumberOfPages) && updatedNumberOfPages > 0) {
        numberOfPages = updatedNumberOfPages
      }
      pageToLoad++
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.warn(e)
      }
    } finally {
      isLoading = false
      newsTrigger?.classList.remove('is-loading')
    }
  }

  // observe trigger
  if (newsTrigger) {
    const newsListObserver = new IntersectionObserver(loadMoreNewsEntries)
    newsListObserver.observe(newsTrigger)
  }

  const newsListSliders = document.querySelectorAll('.news-list--slider')

  for (const newsListSlider of newsListSliders) {
    newsListSlider.querySelector('.swiper-slide')
    newsListSlider.querySelector('.swiper-wrapper')
    new Swiper(newsListSlider.querySelector('.swiper'), {
      modules: [Navigation],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: newsListSlider.querySelector('.news-list__next'),
        prevEl: newsListSlider.querySelector('.news-list__prev'),
      },
      breakpoints: {
        // mobile
        767: {
          slidesPerView: 2, slidesPerGroup: 2,
        },
        // tablet
        1023: {
          slidesPerView: 3, slidesPerGroup: 3,
        },
      },
      loop: false,
    })
  }
}

onDomReady(init)
